import React from "react";
import "../Homepage/home.css";
import Productgrid from "../Homepage/Productgrid";
import { Link } from "react-router-dom";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../../Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../Breadcrumb";
import { FadeLoader } from "react-spinners";
import { motion } from "framer-motion";
import sorticon from "../../assets/images/SORT.png";
import filtericon from "../../assets/images/FILTER.png";
import { useNavigate } from "react-router-dom";
import Notfound from "../../pages/Notfound";

function CategoryPage() {
  const [mainClass, setMainClass] = useState("col-3 four-grid");
  const [activeStick, setActiveStick] = useState("");
  const [loading, setLoading] = useState(true);
  const naviate = useNavigate();
  const [selectedSort, setSelectedSort] = useState(null);

  const user_id = localStorage.getItem("userId");
  const { categorySlug, subcategorySlug, subchildSlug } = useParams();

  const [productsdata, setProductsData] = useState([]);
  const [menucategories, setMenucategories] = useState([]);

  const [categoryheading, setCategoryheading] = useState("");
  const [subcategoryheading, setsubCategoryheading] = useState("");
  const [subchildcategoryheading, setsubchildCategoryheading] = useState("");

  useEffect(() => {
    const mediaQuery991 = window.matchMedia("(max-width: 991px)");
    const mediaQuery767 = window.matchMedia("(max-width: 767px)");
    const mediaQuery575 = window.matchMedia("(max-width: 575px)");

    const handleScreenChange = () => {
      if (mediaQuery575.matches) {
        setMainClass("col-6 two-grid");
        setActiveStick("stick_two");
      } else if (mediaQuery767.matches) {
        setMainClass("col-6 two-grid");
        setActiveStick("stick_two");
      } else if (mediaQuery991.matches) {
        setMainClass("col-6 two-grid");
        setActiveStick("stick_two");
      } else {
        setMainClass("col-3 four-grid");
        setActiveStick("stick_four");
      }
    };

    handleScreenChange();
    mediaQuery575.addEventListener("change", handleScreenChange);
    mediaQuery767.addEventListener("change", handleScreenChange);
    mediaQuery991.addEventListener("change", handleScreenChange);

    // Cleanup event listeners on component unmount
    return () => {
      mediaQuery575.removeEventListener("change", handleScreenChange);
      mediaQuery767.removeEventListener("change", handleScreenChange);
      mediaQuery991.removeEventListener("change", handleScreenChange);
    };
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      await axios
        .get(apiurl + "menu_list")
        .then((res) => {
          setMenucategories(res.data?.data || []);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchProductList = async () => {
      setLoading(true);
      setSelectedSort(null);
      try {
        const response = await axios.post(apiurl + "products_list", {
          category_slug: categorySlug,
          subcategory_slug: subcategorySlug,
          subchildcategory_slug: subchildSlug,
          user_id: user_id,
        });

        setProductsData(response.data?.products ?? []);
        setCategoryheading(response.data?.category_name ?? "");
        setsubCategoryheading(response.data?.subcategory_name ?? "");
        setsubchildCategoryheading(response.data?.subchildcategory_name ?? "");
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product list", error);
        setProductsData([]);
      }
    };

    if (categorySlug || subcategorySlug || subchildSlug) {
      fetchProductList();
    }
  }, [categorySlug, subcategorySlug, subchildSlug]);

  function stickhandleone() {
    setMainClass("col-12 single-grid");
    setActiveStick("stick_one");
  }

  function stickhandletwo() {
    setMainClass("col-6 two-grid");
    setActiveStick("stick_two");
  }

  function stickhandlethree() {
    setMainClass("col-4 three-grid");
    setActiveStick("stick_three");
  }

  function stickhandlefour() {
    setMainClass("col-3 four-grid");
    setActiveStick("stick_four");
  }

  function stickhandlesix() {
    setMainClass("col-2 six-grid");
    setActiveStick("stick_six");
  }

  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const handleCategoryClick = (categoryId) => {
    setActiveCategory((prev) => (prev === categoryId ? null : categoryId));
    setActiveSubcategory(null);
  };

  const handleSubcategoryClick = (subcategoryId) => {
    setActiveSubcategory((prev) =>
      prev === subcategoryId ? null : subcategoryId
    );
  };

  const handleSortChange = async (event) => {
    const value = event.target.value;
    setSelectedSort(value);
    setLoading(true);
    handleSortClose();

    try {
      const res = await axios.post(apiurl + "short_filter", {
        status: value,
        user_id: user_id,
        category_slug: categorySlug,
        subcategory_slug: subcategorySlug,
        subchild_slug: subchildSlug,
      });
      setLoading(false);
      setProductsData(res.data?.products ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const [showSortPopup, setShowSortPopup] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleSortClick = () => {
    if (showSortPopup) {
      setShowSortPopup(false);
    } else {
      setShowSortPopup(true);
      setShowFilterPopup(false);
    }
  };

  const handleFilterClick = () => {
    if (showFilterPopup) {
      setShowFilterPopup(false);
    } else {
      setShowSortPopup(false);
      setShowFilterPopup(true);
    }
  };

  const handlefilterClose = () => {
    setShowFilterPopup(false);
  };

  const handleSortClose = () => {
    setShowSortPopup(false);
  };

  const popupVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, y: 100, transition: { duration: 0.3 } },
  };

  const mainheading = () => {
    if (categoryheading && subcategoryheading && subchildcategoryheading) {
      return <>{subchildcategoryheading}</>;
    } else if (categoryheading && subcategoryheading) {
      return <>{subcategoryheading}</>;
    } else if (categoryheading) {
      return <>{categoryheading}</>;
    }
  };
  const handleFiltercategory = (categorySlug) => {
    naviate(`/${categorySlug}`);
  };

  const handlefilterSubcategory = (categorySlug, subcategorySlug) => {
    naviate(`/${categorySlug}/${subcategorySlug}`);
    handlefilterClose();
  };

  const handlefilterSubchildcategory = (categorySlug, subcategorySlug, subchildSlug) => {
    naviate(`/${categorySlug}/${subcategorySlug}/${subchildSlug}`);
    handlefilterClose();
  };

  if (!loading && menucategories.length > 0) {
    const category = menucategories.find(
      (cat) => cat.category_slug === categorySlug
    );

    if (!category) {
      return <Notfound />;
    }

    if (subcategorySlug) {
      const subcategory = category.subcategory?.find(
        (sub) => sub.subcategory_slug === subcategorySlug
      );

      if (!subcategory) {
        return <Notfound />;
      }

      if (subchildSlug) {
        const subchild = subcategory.subchildcategory?.find(
          (child) => child.subchild_slug === subchildSlug
        );

        if (!subchild) {
          return <Notfound />;
        }
      }
    }
  }

  return (
    <>
      <Breadcrumb
        title_1="Home"
        title_2={!loading ? categoryheading : null}
        title_3={!loading ? subcategoryheading : null}
        title_4={!loading ? subchildcategoryheading : null}
        categorySlug={categorySlug}
        subcategorySlug={subcategorySlug}
        subchildSlug={subchildSlug}
      />
      <section className="category_page_section col_divide_design  pt-40 pb-40">
        <div className="container">
          <div className="row">
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12">
              <div className="left-inner-box">
                <div className="inner-box">
                  <div>
                    {menucategories.length > 0
                      ? menucategories.map((category, index) => {
                          return (
                            <div key={index} className="main_category">
                              <h6
                                onClick={() => handleCategoryClick(category.id)}
                              >
                                <Link to={`/${category.category_slug}`}>
                                  {category.category_name}
                                </Link>
                              </h6>
                              {activeCategory === category.id && (
                                <ul className="sub_category">
                                  {category.subcategory.map(
                                    (subcategory, index) => (
                                      <li key={index}>
                                        <p
                                          onClick={() =>
                                            handleSubcategoryClick(
                                              subcategory.id
                                            )
                                          }
                                        >
                                          <Link
                                            to={`/${category.category_slug}/${subcategory.subcategory_slug}`}
                                          >
                                            {subcategory.subcategory_name}
                                          </Link>
                                          <FontAwesomeIcon
                                            icon={
                                              activeSubcategory ===
                                              subcategory.id
                                                ? faAngleUp
                                                : faAngleDown
                                            }
                                            style={{ marginLeft: "8px" }}
                                          />
                                        </p>
                                        {activeSubcategory ===
                                          subcategory.id && (
                                          <ul className="subchild_category">
                                            {subcategory.subchildcategory.map(
                                              (item, index) => (
                                                <li key={index}>
                                                  <Link
                                                    to={`/${category.category_slug}/${subcategory.subcategory_slug}/${item.subchild_slug}`}
                                                  >
                                                    {item.subchildcategoryname}
                                                  </Link>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div className="filters_two mt-5">
                    <h6>Sort By</h6>
                    <ul className="mt-3">
                      <li>
                        <input
                          type="radio"
                          name="sort_filter"
                          onChange={handleSortChange}
                          checked={selectedSort === "1"}
                          value="1"
                          id="sort_a_to_z"
                        />
                        &nbsp;&nbsp;<label htmlFor="sort_a_to_z">A to Z</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="sort_filter"
                          onChange={handleSortChange}
                          checked={selectedSort === "2"}
                          value="2"
                          id="sort_z_to_a"
                        />
                        &nbsp;&nbsp;<label htmlFor="sort_z_to_a">Z to A</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="sort_filter"
                          onChange={handleSortChange}
                          checked={selectedSort === "3"}
                          value="3"
                          id="sort_low_to_high"
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="sort_low_to_high">Low to High</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="sort_filter"
                          onChange={handleSortChange}
                          checked={selectedSort === "4"}
                          value="4"
                          id="sort_high_to_low"
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="sort_high_to_low"> High to Low</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-10 col-lg-9 col-md-8 col-sm-12 right-inner-box">
              <div className="row first_row">
                <div className="col-xl-3 col-lg-3 main-stick-inner">
                  <div className="main-stick">
                    <div
                      onClick={stickhandleone}
                      className={`${
                        activeStick === "stick_one"
                          ? "active-bg-grid"
                          : "sticks-inner-box"
                      } stick_one`}
                    >
                      <button
                        className={
                          activeStick === "stick_one"
                            ? "stickhandleone-one"
                            : "stick-color"
                        }
                      ></button>
                    </div>
                    <div
                      onClick={stickhandletwo}
                      className={`${
                        activeStick === "stick_two"
                          ? "active-bg-grid"
                          : "sticks-inner-box"
                      } stick_two`}
                    >
                      <button
                        className={
                          activeStick === "stick_two"
                            ? "stickhandleone-two"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_two"
                            ? "stickhandleone-two"
                            : "stick-color"
                        }
                      ></button>
                    </div>
                    <div
                      onClick={stickhandlethree}
                      className={`${
                        activeStick === "stick_three"
                          ? "active-bg-grid"
                          : "sticks-inner-box"
                      } stick_three`}
                    >
                      <button
                        className={
                          activeStick === "stick_three"
                            ? "stickhandleone-three"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_three"
                            ? "stickhandleone-three"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_three"
                            ? "stickhandleone-three"
                            : "stick-color"
                        }
                      ></button>
                    </div>
                    <div
                      onClick={stickhandlefour}
                      className={`${
                        activeStick === "stick_four"
                          ? "active-bg-grid"
                          : "sticks-inner-box"
                      } stick_four`}
                    >
                      <button
                        className={
                          activeStick === "stick_four"
                            ? "stickhandleone-four"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_four"
                            ? "stickhandleone-four"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_four"
                            ? "stickhandleone-four"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_four"
                            ? "stickhandleone-four"
                            : "stick-color"
                        }
                      ></button>
                    </div>
                    <div
                      onClick={stickhandlesix}
                      className={`${
                        activeStick === "stick_six"
                          ? "active-bg-grid"
                          : "sticks-inner-box"
                      } stick_five`}
                    >
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                      <button
                        className={
                          activeStick === "stick_six"
                            ? "stickhandleone-five"
                            : "stick-color"
                        }
                      ></button>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-9 main-heading-inner-box">
                  <div className="inner-box">
                    <img
                      src={leftTree}
                      alt="img"
                      className="heading-left-image"
                    />
                    {!loading ? (
                      <h3 className="main-heading-1">{mainheading()}</h3>
                    ) : null}

                    <img
                      src={righttree}
                      alt="img"
                      className="heading-right-image"
                    />
                  </div>
                </div>
              </div>

              <div className="row second_row">
                {loading ? (
                  <div
                    className="col-12 d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "30px",
                    }}
                  >
                    {/* <FadeLoader size={100} /> */}
                    <div class="dot-spinner">
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                      <div class="dot-spinner__dot"></div>
                    </div>
                  </div>
                ) : (
                  <>
                    {productsdata && productsdata.length > 0 ? (
                      productsdata.map((item, index) => (
                        <React.Fragment key={index}>
                          <div className={`${mainClass} product_grid_col`}>
                            <Productgrid
                              items={item}
                              productdetailslink={`/product-details/${item.slug}`}
                            />
                          </div>
                        </React.Fragment>
                      ))
                    ) : (
                      <p className="text-center mt-5 mb-0">No Products Found</p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {showSortPopup && (
        <motion.div
          className="sort_options_popup"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={popupVariants} // Use the variants defined above
        >
          <div className="popup_content">
            <h3>
              Sort
              <button onClick={handleSortClose}>
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </h3>

            <div>
              <ul className="mt-3">
                <li>
                  <input
                    type="radio"
                    name="sort_filter"
                    id="sort_a_to_z"
                    onChange={handleSortChange}
                    value="1"
                    checked={selectedSort === "1"}
                  />
                  &nbsp;&nbsp;<label htmlFor="sort_a_to_z">A to Z</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="sort_filter"
                    id="sort_z_to_a"
                    onChange={handleSortChange}
                    value="2"
                    checked={selectedSort === "2"}
                  />
                  &nbsp;&nbsp;<label htmlFor="sort_z_to_a">Z to A</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="sort_filter"
                    id="sort_low_to_high"
                    onChange={handleSortChange}
                    value="3"
                    checked={selectedSort === "3"}
                  />
                  &nbsp;&nbsp;
                  <label htmlFor="sort_low_to_high">Low to High</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="sort_filter"
                    id="sort_high_to_low"
                    onChange={handleSortChange}
                    value="4"
                    checked={selectedSort === "4"}
                  />
                  &nbsp;&nbsp;
                  <label htmlFor="sort_high_to_low"> High to Low</label>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      )}
      {showFilterPopup && (
        <motion.div
          className="filter_options_popup"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={popupVariants}
        >
          <div className="popup_content">
            <h3>
              Filter
              <button onClick={handlefilterClose}>
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </h3>

            <div className="mt-3">
              {menucategories.length > 0
                ? menucategories.map((category, index) => {
                    return (
                      <div key={index} className="main_category">
                        <h6 onClick={() => handleCategoryClick(category.id)}>

                          <a onClick={() => handleFiltercategory(category.category_slug)}>
                            {category.category_name}
                          </a>

                          {/* </Link> */}
                        </h6>
                        {activeCategory === category.id && (
                          <ul className="sub_category">
                            {category.subcategory.map((subcategory, index) => (
                              <li key={index}>
                                <p
                                  onClick={() =>
                                    handleSubcategoryClick(subcategory.id)
                                  }
                                >
                                  <a
                                    onClick={() =>
                                      handlefilterSubcategory(category.category_slug, subcategory.subcategory_slug)
                                    }
                                  >
                                    {subcategory.subcategory_name}
                                  </a>
                                  <FontAwesomeIcon
                                    icon={
                                      activeSubcategory === subcategory.id
                                        ? faAngleUp
                                        : faAngleDown
                                    }
                                    style={{ marginLeft: "8px" }}
                                  />
                                </p>
                                {activeSubcategory === subcategory.id && (
                                  <ul className="subchild_category">
                                    {subcategory.subchildcategory.map(
                                      (item, index) => (
                                        <li key={index}>
                                          <a
                                            onClick={() =>
                                              handlefilterSubchildcategory(
                                                category.category_slug,
                                                subcategory.subcategory_slug,
                                                item.subchild_slug
                                              )
                                            }
                                          >
                                            {item.subchildcategoryname}
                                          </a>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </motion.div>
      )}
      <div className="category_sticky">
        <div className="row">
          <div className="col-12">
            <div className="inner_box">
              <button className="btn_1_1" onClick={handleSortClick}>
                <img src={sorticon} alt="Sort Icon" /> <span> Sort</span>
              </button>
              <button className="btn_1_1" onClick={handleFilterClick}>
                <img src={filtericon} alt="Filter Icon" /> <span>Filter</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CategoryPage;
